<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emMaMaintenanceScheduleResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="right-header">
                                    <b-button-group>
                                        <em-button type="runPlans"
                                                   v-bind:class="'btn btn-outline-primary'"
                                                   showName
                                                   @click="$_emPlanHelperMixin_runPlans">
                                        </em-button>
                                        <em-button type="runDuePlans"
                                                   v-bind:class="'btn btn-outline-primary'"
                                                   showName
                                                   @click="$_emPlanHelperMixin_runDuePlans">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-07-21 10:00:52

import emCommonListMixin from "@/mixin/em/common/list";
import emPlanHelperMixin from "@/mixin/em/helper/plan";

export default {
    name: "emMaMaintenanceScheduleListView",
    mixins: [emCommonListMixin, emPlanHelperMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    }
};
</script>